import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { Button, Image } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import Layout from "components/sales/layout/layout";
import GSTDetails from "components/sales/formSection/GSTDetails/gstDetails";
// import ParkingRules from "components/sales/formSection/parkingRules/parkingRules";
import MaterialHardware from "components/sales/formSection/materialHardware/materialHardware";
import ShippedTo from "components/sales/formSection/shippedTo/shippedTo";
import BilledTo from "components/sales/formSection/billedTo/billedTo";
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import OtherDetailsApt from "components/sales/formSection/otherDetails/otherDetailsApt";
import GateDetails from "components/sales/formSection/gateDetails/gateDetailsApt";
// import DummyAdd from "components/sales/formSection/gateDetails/dummyAdd";
import Commercial from "components/sales/formSection/commercial/commercial";
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import AgreementContract from "components/sales/formSection/agreementContract/agreementContract";
import Checkbox from "components/sales/Input/checkbox/checkbox";
import Tags from 'components/sales/formSection/materialHardware/tags';
import AdvancePayment from 'components/sales/formSection/materialHardware/advancePayment';
import Increament from 'components/sales/formSection/materialHardware/increament';
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModule';
import AddPoc from "../../../../components/sales/formSection/addPoc/addPoc";
import SaleType from "components/sales/formSection/saleType/saleType";
import B2BRevenue from "../B2BRevenue";
import ContractServices from "../ContractServices";
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';


const PostSalesApartment = (props) => {
  const {
    history,
    postApartment,
    postApartmentData,
    pincodeData,
    locationPinCode,
    postSalesApartmentLead,
    documentUploadUrl,
    documentUrlData,
    match,
    getMaterial,
    getMateriaById,
    getBrandById,
    getBrand,
    imageUploadUrl,
    videoUploadUrl,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress,
    getContractRevenue,
    contractRevenueDetails=[],
    getContractService,
    contractCatService=[]
  } = props;
  const { params } = match;
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    parkingRules: null,
    shippedTo: null,
    // billedTo: null,
    clientData: null,
    otherDetails: null,
    gateDetails: null,
    category: [],
    materialHardwares: 'No',
    gates: null,
    tags:[],
    installation: null,
    InvoiceModuleData:null,
    pocData: null,
    revenue_nature: 'Self',
    revenue_type:'Fixed',
    invoice_type:'Post',
  };

  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  // const [sameAsBillTo, setSameAsBillTo] = useState(null);
  const [variableServices, setVariableServices] = useState([{id:'', amount:'', qty:'', men_days:0, start_day:'', end_day:''}])
  const [fixedServices, setFixedServices] = useState([{id:'', amount:'', qty:'', men_days:0}])

  const [postApartmentInputs, setPostApartmentData] = useState(postDataInputs);
  const handleCommercial = (val) => {
    setPostApartmentData({ ...postApartmentInputs, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
      // console.log(val);
    }
  };
  const handleGstDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gSTDetails: val });
  };
  const handleParkingRules = (val) => {
    setPostApartmentData({ ...postApartmentInputs, parkingRules: val });
  };

  const handleGateDtl = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostApartmentData({ ...postApartmentInputs, milestone: val });
  };
  // const handleBillTo = (val) => {
  //   setPostApartmentData({ ...postApartmentInputs, billedTo: val });
  // };
  const handleShippedTo = (val) => {
    setPostApartmentData({ ...postApartmentInputs, shippedTo: val });
  };
  const handleClientData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, clientData: val });
  };
  const handlePocData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, pocData: val });
  };
  const handleOtherDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    setPostApartmentData({ ...postApartmentInputs, materialHardwares: val });
  };
  const handleagreementDtls = (val) => {
    setPostApartmentData({ ...postApartmentInputs, agreementDtls: val });
  };
  const handlesalesTypeDtls = (val) => {
    setPostApartmentData({ ...postApartmentInputs, salesTypeDetails: val });
  };
  const handleTags = (val) => {
    setPostApartmentData({ ...postApartmentInputs, tagsData: val });
  };
  const handleInstallation = (val) => {
    setPostApartmentData({ ...postApartmentInputs, installation: val });
  };
  const handlePayment = (val) => {
    setPostApartmentData({ ...postApartmentInputs, advPayment: val });
  };
  const handleIncreament = (val) => {
    setPostApartmentData({ ...postApartmentInputs, increamentData: val });
  }; 
  const handleInvoiceAmt = (val) => {
    setPostApartmentData({ ...postApartmentInputs, InvoiceModuleData: val });
  }; 

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  const handleRevenueDetails = (key, value) => {
    postApartmentInputs[key] = value
    setPostApartmentData(postApartmentInputs);
  }

  const handleSubmit = (id) => {
    setIsClicked(true);
    const {
      commercial,
      gSTDetails,
      parkingRules,
      gateDetails,
      // billedTo,
      shippedTo,
      clientData,
      otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      agreementDtls,
      advPayment,
      installation,
      increamentData,
      tagsData,
      InvoiceModuleData,
      milestone,
      salesTypeDetails,
      // pocData
      revenue_nature,
      revenue_type,
      invoice_type
    } = postApartmentInputs;
      // console.log(postApartmentInputs); //return false;
    if(postApartmentData.leadStatus !== 9 && (revenue_nature === null || revenue_nature === '')){
      toast.warning("Please contract revenue nature")
      return false
    }
    if (
      (postApartmentData.leadStatus <= 4 && (
          commercial != null &&
          gSTDetails != null &&
          // billedTo != null &&
          shippedTo != null &&
          agreementDtls != null &&
          clientData != null
          // && pocData !== null
      )) || (postApartmentData.leadStatus === 9 && postApartmentData?.commercialData?.revenue_nature !== 'Valet' && (gateDetails != null))
        || (postApartmentData.leadStatus === 9 && (gateDetails != null && MaterialHardware != null && materialHardwares != null))
      // parkingRules === null ||

    ) {
      setIsFiled(false);
      if(postApartmentData.leadStatus <= 4 && salesTypeDetails == null) {
          toast.error('Please fill Type of sales details.');
          return false;
      }
      if(postApartmentData.leadStatus <= 4 && salesTypeDetails != null) {
          if(salesTypeDetails.salesType !== 'Direct Sales') {
            if(salesTypeDetails.channelPartner == '' || salesTypeDetails.channelPartner == null) {
              toast.error('Please fill channel partner under section type of sales.');
              return false;
            } else if(salesTypeDetails.channelPartner === 'Others') {
               if(salesTypeDetails.channelPartnerValue == null || salesTypeDetails.channelPartnerValue == '') {
                 toast.error('Please fill channel partner name under section type of sales.');
                 return false;
               }
            }
          }
      }
      //console.log('All good'); return false;
      if(clientData != null && clientData.billing_address !== undefined){
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          isNewContract:1,
          gateDetails: gateDetails,
          leadStatus:postApartmentData.leadStatus,
          comm_id:postApartmentData.comm_id,
          materialHardwares: { ...materialHardwares },
          ...clientData.billing_address,
          // pocData: pocData,
          ...salesTypeDetails
        }; 
      }else{
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          isNewContract:1,
          leadStatus:postApartmentData.leadStatus,
          comm_id:postApartmentData.comm_id,
          materialHardwares: { ...materialHardwares },
          // pocData: pocData
          // ...clientData.billing_address
          ...salesTypeDetails
        }; 
      }

      // if (categoryInventory !== null && categoryInventory !== undefined) {
      //   fObj.categoryInventory = [
      //     ...categoryInventory,
      //     ...productInventory?.productData,
      //   ];
      // } else {
      //   fObj.categoryInventory = [];
      // }

      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      }


      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }
      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        if (increamentData?.inc?.increament_type) {
          if (increamentData?.inc?.increament_type == 'flat' || increamentData?.inc?.increament_type == 'percentage') {
            if (increamentData?.inc?.duration == undefined || increamentData?.inc?.increament_amount == undefined) {
              return false;
            }
          }
          fObj.increament = [
            increamentData
          ];
        } else {
          fObj.increament = [];
        }
      } else {
        fObj.increament = [];
      }
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(postApartmentData?.commercialData?.total_mg_amount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postApartmentInputs.milestone?.milestone_data.length; i++) {
              if (postApartmentInputs.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.date_invoices_data.length; i++) {
              if (postApartmentInputs.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.retention.length; i++) {
              if (postApartmentInputs.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.retention[i].amt);
              }
            }
            if (calculatedAmt > totalAmt) {
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            } else {
              fObj.milestone=milestone;
            }
          }
        }
      }
      fObj['revenue_nature'] = revenue_nature
      fObj['revenue_type'] = revenue_type
      fObj['invoice_type'] = invoice_type
      if(postApartmentData?.commercialData !== undefined && postApartmentData?.commercialData?.revenue_nature === 'Valet'){
        fObj['variable_services'] = variableServices
        fObj['fixed_services'] = fixedServices
      }else{
        fObj['invoice_type'] = 'Pre'
        fObj['revenue_type'] = 'Fixed'
      }

      if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
        let subsAmt = Number(postApartmentData?.commercialData?.subscription_amount);
        let invoiceAmt = InvoiceModuleData?.invoiceAmt;
        const initialValue = 0;
        const sumWithInitial = invoiceAmt.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
        );
        console.log(sumWithInitial);
        if(subsAmt === sumWithInitial ){
          fObj.InvoiceModuleData=InvoiceModuleData;
        }else{
          toast.error('Total amount of invoice module is not equal to the total subscription amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }
       

        console.log(fObj)
      }
      //console.log(fObj); return false;
      (async () => {
        const res = await postSalesApartmentLead({ ...fObj, leadId: id });
        if (res) {
          setIsModal(true);
        }
      })();
      
    } else {
      setIsClicked(false);
      // console.log(agreementDtls)
      setIsFiled(true);
      setIsFiled(true);
      const active = document.querySelector('.activeAnkInput');
      console.log(active);
      if(active){
        active.focus();
      }else{
        alert('Please Upload missed documents or enter valid data!')
      }
    }
  };

  useEffect(() => {
    (async () => {
      await postApartment(params.lead_id)
      await getContractRevenue()
      await getContractService('VALET')
    })();
  }, [postApartment]);

  // console.log(postApartmentData.leadStatus);

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(params.lead_id)} /* disabled={isClicked} */>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };
  function refreshPage() {
    window.location.reload(false);
  }

  const handleVariableService = (index, key, val) => {
    let list = [...variableServices]
    console.log(list)
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      variableServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setVariableServices(list)
        toast.warning("Service already selected.")
      }, 1000)
       return false
    }

    list[index][key] = val
    setVariableServices(list)
  }

  const handleFixedService = (index, key, val) => {
    let list = [...fixedServices]
    let isAlreadyExist = false
    if(list.length > 1 && key === 'id'){
      fixedServices.map((vali, i) => {
        if(parseInt(vali?.id) === parseInt(val)){
          isAlreadyExist = true
        }
      })
    }

    if(isAlreadyExist){
      setTimeout(() => {
        list.splice(list.length-1, 1)
        setFixedServices(list)
        toast.warning("Service already selected.")
      }, 1000)
      return false
    }

    list[index][key] = val
    setFixedServices(list)
  }

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
      title={localization.addPost}
    >

      {postApartmentData.leadStatus <= 4 && (
        <>
        <B2BRevenue
            RevenueData={contractRevenueDetails}
            handleValue={handleRevenueDetails}
        />
      <Commercial
        is_fastag={1}
        data={postApartmentData}
        handleValue={handleCommercial}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        supplyNameFun={supplyNameFun}
        splNameData={splNameData}
      />
      {/* {showAgreementDetails == true && ( */}
        <AgreementContract
          isApartment={1}
          handleValue={handleagreementDtls}
          documentUploadUrl={documentUploadUrl}
          agreementLength={agreementLength}
          showDetails={showAgreementDetails}
        />
      {/* )} */}
      <SaleType
          isApartment={1}
          handleValue={handlesalesTypeDtls}
          documentUploadUrl={documentUploadUrl}
          agreementLength={agreementLength}
          showDetails={true}
        />
      <GSTDetails
        handleValue={handleGstDetails}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      {/*  <BilledTo
        handleValue={handleBillTo}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
      />
       <Checkbox
        label={"Same shipping address"}
        type="checkbox"
        errorMsg={localization.isRequired}
        onChange={(val) => {
          if (val) {
            setSameAsBillTo(postApartmentInputs.billedTo);
          } else {
            setSameAsBillTo({
              billPinCode: "",
              billGeoCity: "",
              billGeoState: "",
              billGeoCityId: "",
              billGeoStateId: "",
              billPinId: "",
              billAddressLine1: "",
              billAddressLine2: "",
            });
          }
        }}
      /> */}
      <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        leadData={postApartmentData.lead_name}
        // sameAsBillTo={sameAsBillTo}
      />
      <ClientDetails
        handleValue={handleClientData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        data={postApartmentData}
        clientBillingAddress={clientBillingAddress}
        clientBillingPocData={clientBillingPocData}
      />
        {/*<AddPoc
          handleValue={handlePocData}
        />*/}
      </>
      )}
      {/* <ParkingRules
        isApartment
        handleValue={handleParkingRules}
        data={postApartmentData}
      /> */}
      {postApartmentData.leadStatus === 9 && (
        <>

          <GateDetails
              handleValue={handleGateDtl}
              data={postApartmentData}
              imageUploadUrl={imageUploadUrl}
              videoUploadUrl={videoUploadUrl}
          />
          {postApartmentData?.commercialData !== undefined && postApartmentData?.commercialData?.revenue_nature !== 'Valet' &&
            <MaterialHardware
                handleValue={handleMaterialhardware}
                data={postApartmentData}
                handleGatesData={handleGatesData}
                handleProductData={handleProductData}
                getMaterial={getMaterial}
                getBrandById={getBrandById}
                getBrand={getBrand}
                getMateriaById={getMateriaById}
            />
          }
          {postApartmentData?.commercialData !== undefined && postApartmentData?.commercialData?.revenue_nature === 'Valet' &&
              <ContractServices
                  serviceDetails={contractCatService}
                  setVariableServices={setVariableServices}
                  variableServices={variableServices}
                  handleVariableService={handleVariableService}
                  handleFixedService={handleFixedService}
                  handleValue={handleRevenueDetails}
                  setFixedServices={setFixedServices}
                  fixedServices={fixedServices}
                  commercialData={postApartmentData?.commercialData}
              />
          }

          {postApartmentData?.commercialData !== undefined && postApartmentData?.commercialData?.revenue_nature !== 'Valet' &&
              <Tags
                  handleValue={handleTags}
                  data={postApartmentData}
              />
          }
      {postApartmentData.commercialData?.commercial_type_id === 7 && (
        <InvoiceModule
          handleValue={handleInvoiceAmt}
          data={postApartmentData} 
          prefilledData={postApartmentData?.postsale_data}
          invoiceAmtData = {postApartmentData?.postsale_data}
          isdisable={true}
        />
      )}
      {postApartmentData.commercialData?.commercial_type_id === 5 && (
          <Milestone
            handleValue={handleMileStone}
            totalAmount={postApartmentData?.commercialData.total_mg_amount}
            gateData={postApartmentInputs?.gateDetails}
            gateDetailsChanged = {setIsGateDetailsChanged} 
            isGateDetailsChanged = {isGateDetailsChanged} 
          />
      )}
      {/* <DummyAdd
        handleValue={handleGateDtl}
        data={postApartmentData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      /> */}

      {postApartmentData?.commercialData !== undefined && postApartmentData?.commercialData?.revenue_nature !== 'Valet' &&
          <Installation
            isApartment={1}
            handleValue={handleInstallation}
          />
      }
      <div className="col-md-6">
        {/* <FileUpload
                // id={`document`}
                accept=".pdf,.png,.jpg,.jpeg,.doc"
                // documentUploadUrl={documentUploadUrlPublic}
                // documentUrlData={documentUrlDataPublic}
                // onChange={(val) =>
                //   handleValues(val,"document")
                // }
              >
              <span className="btn btn-transparent">
                {localization.document}
              </span>
        </FileUpload> */}
      </div>
      <AdvancePayment
        handleValue={handlePayment}
        data={postApartmentData}
        imageUploadUrl={imageUploadUrl}
      />

          {postApartmentData?.commercialData !== undefined && postApartmentData?.commercialData?.revenue_nature !== 'Valet' &&
            <Increament
              handleValue={handleIncreament}
              data={postApartmentData}
              imageUploadUrl={imageUploadUrl}
            />
          }

      {/* <OtherDetailsApt
        isApartment
        handleValue={handleOtherDetails}
        data={postApartmentData}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      /> */}
      </>
      )}
      {postApartmentData.leadStatus <= 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <button onClick={refreshPage} className="btn btn-primary mb-4">
          {localization.saveAndNext} <img src={Images?.ArrowRight} alt="" />
          </button>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link> */}
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      )}
      {postApartmentData.leadStatus != 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      )}


    </Layout>
  );
};

PostSalesApartment.propTypes = {
  history: propTypes.any,
};

export default PostSalesApartment;

